import Cookies from "js-cookie";

/*
 * 设置setLocalStorage
 * */
export function setLocalStorage (key, value) {
    window.localStorage.setItem(key, window.JSON.stringify(value));
}
/*
 * 获取getLocalStorage
 * */
export function getLocalStorage (key) {
    return window.JSON.parse(window.localStorage.getItem(key));
}
/*
 * 设置setSessionStorage
 * */
export function setSessionStorage (key, value) {
    window.sessionStorage.setItem(key, window.JSON.stringify(value));
}
/*
 * 获取getSessionStorage
 * */
export function getSessionStorage (key) {
    return window.JSON.parse(window.sessionStorage.getItem(key));
}
/*
 * 获取getToken
 * */
export function getToken (TokenKey) {
    return Cookies.get(TokenKey);
}
/*
 * 设置setToken
 * */
export function setToken (TokenKey, token, expire) {
    let expireSeconds = expire || 2 * 60 * 60;
    let expireDate = new Date(new Date().getTime() + expireSeconds * 1000);
    return Cookies.set(TokenKey, token, {
        expires: expireDate
    });
}
/*
 * 移除removeToken
 * */
export function removeToken (TokenKey) {
    return TokenKey ? Cookies.remove(TokenKey) : Cookies.remove();
}